export enum FilterTypeLib {
  // @export
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  Swap = 'swap',
  Buy = 'buy_crypto',
  Bill = 'bill',
  // 后端要求大写
  Bonus = 'Bonus',
  Game = 'Game',
  BetHistory = 'bet_history',
  All = '',
}

export function getTypeOptions() {
  return [
    { label: () => t('All'), value: '' },
    { label: () => t('Transfer'), value: 'TRANSFER' },
    { label: () => t('Deposit'), value: 'RECHARGE' },
    { label: () => t('Withdraw'), value: 'WITHDRAW' },
    { label: () => t('Vault Deposit'), value: 'VAULT_DEPOSIT' },
    { label: () => t('Vault Withdraw'), value: 'VAULT_WITHDRAW' },
    { label: () => t('Bet Placed'), value: 'BET_PLACED' },
    { label: () => t('Bet Won'), value: 'BET_WON' },
    { label: () => t('Bet Refunded'), value: 'BET_REFUNDED' },
    { label: () => t('Bet Cancelled'), value: 'BET_CANCELLED' },
    { label: () => t('Cash Out'), value: 'CASH_OUT' },
    { label: () => t('Settlement Cancelled'), value: 'SETTLEMENT_CANCELLED' },
    { label: () => t('Credit Repayment'), value: 'REPAYMENT' },
    { label: () => t('Credit Auto-Repayment'), value: 'AUTO_REPAYMENT' },
    { label: () => t('Credits Issued'), value: 'CREDITS_ISSUED' },
    { label: () => t('Credits Reduce'), value: 'CREDITS_REDUCE' },
    { label: () => t('Campaign'), value: 'CAMPAIGN' },
    { label: () => t('Referral Rewards'), value: 'REFERRAL_REWARDS' },
    { label: () => t('Promo Code'), value: 'PROMO_CODE' },
  ];
}

export function getTransactionLabel(type: string) {
  const findOption = getTypeOptions().find((item) => item.value === type);
  return findOption?.label() || type;
}
